"use strict";

exports.__esModule = true;
exports.targetTimeWindowCheck = exports.mergeAggregatedDataByKey = exports.isPercentageMetric = exports.isMillis = exports.formatMetricData = exports.formatByTimeBin = void 0;
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _bins = require("../../VIMANAMetrics/bins");
var _constants = require("../../constants");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _Catalogs = require("../../../Catalogs");
var _sortFormattedDataByTimeBin = require("./sortFormattedDataByTimeBin");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formatMetricData = exports.formatMetricData = function formatMetricData(_ref) {
  var data = _ref.data,
    selectedMetric = _ref.selectedMetric,
    aggregations = _ref.aggregations,
    devicesList = _ref.devicesList,
    timeAggregationName = _ref.timeAggregationName,
    time = _ref.time,
    targets = _ref.targets;
  if (!data || data.length === 0) {
    return {
      axis: [],
      series: [],
      legend: [],
      timeBinName: "",
      metricName: ""
    };
  }

  /**
   * SMELL:: Metric endpoint returns key as hour when bin is by_hour
   *         while Measure endpoint return it as by_hour key
   * */
  // Get the timeBinName or key of time in data. EG: hour, day, week, etc
  var timeBinName = (0, _timeAggregationBinMapping.getTimeGroupingBinName)(timeAggregationName).replace("by_", "");

  /**
   * For HOUR_PER_DAY aggregation the the time we receive is not in Plant time and is rather in UTC
   * So if timeAggregationName is HOUR_PER_DAY them convert the data to Plant Time.
   * */
  var plantTimeData = data;

  // Creating a list of aggregation "bin names" except time aggregation
  var aggregationsNameList = aggregations.reduce(function (acc, agg) {
    if (agg.id !== "workday") {
      var aggName = agg.name;
      var aggBinName = (0, _bins.getBinName)(aggName).replace("by_", "");
      return [].concat(acc, [aggBinName]);
    }
    return acc;
  }, []);

  // Creating an Object with keys as deviceuuid and value as Device Name
  var deviceHashMap = devicesList.reduce(function (acc, device) {
    if (acc === void 0) {
      acc = {};
    }
    acc[device.uuid] = device.name;
    return acc;
  }, {});
  //if data has device , swap device-ids with device-names
  plantTimeData = plantTimeData.map(function (it) {
    return it && it["device"] ? Object.assign({}, it, {
      device: deviceHashMap[it["device"]]
    }) : it;
  });
  // Sort the data based on DeviceName and not deviceuuid(returned from server) using deviceHashMap
  // Also sorting the data based on shift.
  plantTimeData.sort(function (a, b) {
    var _a$device, _a$shift;
    return (
      // $FlowFixMe - Flow does not yet support method or property calls in optional chains.
      ((_a$device = a.device) == null ? void 0 : _a$device.localeCompare(b.device)) || (// $FlowFixMe - Flow does not yet support method or property calls in optional chains.
      (_a$shift = a.shift) == null ? void 0 : _a$shift.localeCompare(b.shift))
    );
  });
  return mergeAggregatedDataByKey({
    timeBinName: timeBinName,
    metricName: selectedMetric,
    aggregationsNameList: aggregationsNameList.sort(),
    data: plantTimeData,
    time: time,
    targets: targets,
    deviceHashMap: deviceHashMap,
    timeAggregationName: timeAggregationName
  });
};
var getMetricValue = function getMetricValue(value, metricName) {
  return Number(isPercentageMetric(metricName) ? (value * 100).toFixed(2) : isMillis(metricName) ? (value / _timeDefinitions.HOUR_IN_MILLIS).toFixed(2) : value);
};
var formatByTimeBin = exports.formatByTimeBin = function formatByTimeBin(it, timeBinName, time) {
  if (timeBinName.includes("hour")) {
    if (timeBinName === "hour") return it;
    return _momentTimezone["default"].utc(it).tz(time.timezone.name).format("hh:mm");
  } else {
    return _momentTimezone["default"].utc(it).format("Do MMM");
  }
};
var isPercentageMetric = exports.isPercentageMetric = function isPercentageMetric(metricName) {
  var metric = _Catalogs.metricDefinitions.find(function (it) {
    return it.name === metricName;
  });
  return metric && metric.units === _constants.METRICS_FRACTIONAL_PERCENT;
};
var isMillis = exports.isMillis = function isMillis(metricName) {
  var metric = _Catalogs.metricDefinitions.find(function (it) {
    return it.name === metricName;
  });
  return metric && metric.units === _constants.METRICS_MILLISECOND;
};
var targetTimeWindowCheck = exports.targetTimeWindowCheck = function targetTimeWindowCheck(target, timeBinName, timeBin, time) {
  var _time$timezone, _time$timezone2;
  return timeBinName !== "hour" && _momentTimezone["default"].utc(timeBin).isBetween(_momentTimezone["default"].tz(target.startWorkday, "YYYY-MM-DD", (_time$timezone = time.timezone) == null ? void 0 : _time$timezone.name), _momentTimezone["default"].tz(target.endWorkday, "YYYY-MM-DD", (_time$timezone2 = time.timezone) == null ? void 0 : _time$timezone2.name), "date", "[]");
};

/**
 *The flattened data is aggregated based on each device/shift values.
 * Hence merging them based on the key(time)
 * output -->
 {axisData : ['day-1','day-2', ...] , series : [{name: 'shift-1' , data : [...]} ...]
 * */
var mergeAggregatedDataByKey = exports.mergeAggregatedDataByKey = function mergeAggregatedDataByKey(_ref2) {
  var timeBinName = _ref2.timeBinName,
    metricName = _ref2.metricName,
    aggregationsNameList = _ref2.aggregationsNameList,
    data = _ref2.data,
    time = _ref2.time,
    targets = _ref2.targets,
    deviceHashMap = _ref2.deviceHashMap,
    timeAggregationName = _ref2.timeAggregationName;
  var yAxisMaxVal = 0;
  var binNames = aggregationsNameList.join(",");
  var formattedData = data.map(function (it) {
    it[binNames] = aggregationsNameList.map(function (itt) {
      return it[itt];
    }).join(",");
    return it;
  });
  var sortedFormattedDataForAxis = (0, _sortFormattedDataByTimeBin.sortFormattedDataByTimeBin)({
    timeAggregationName: timeAggregationName,
    formattedValues: formattedData.map(function (it) {
      return it[timeBinName];
    }),
    time: time
  });
  var axisSet = new Set(sortedFormattedDataForAxis);
  var series = [];
  var bins = {};
  [binNames].forEach(function (bin) {
    bins[bin] = new Set();
    formattedData.map(function (it) {
      return bins[bin].add(it[bin]);
    });
    Array.from(bins[bin]).map(function (it) {
      return series.push({
        name: it,
        data: [],
        markPoint: {
          data: []
        },
        type: "bar",
        bin: bin
      });
    });
  });
  var axis = Array.from(axisSet);
  axis.forEach(function (workday) {
    var filteredByWorkDay = formattedData.filter(function (it) {
      return it[timeBinName] === workday;
    });
    series.forEach(function (bin) {
      var binnedData = filteredByWorkDay.find(function (it) {
        return it[bin["bin"]] === bin.name;
      });
      var metricValue = binnedData ? getMetricValue(binnedData[metricName], metricName) : 0;
      bin.data.push(metricValue);
      yAxisMaxVal = Math.max(yAxisMaxVal, metricValue);
      targets.filter(function (target) {
        var shiftPredicate = function shiftPredicate(shiftIndex, itemDevice, targetDevices) {
          return targetDevices.includes(itemDevice) && target.period === _constants.METRICS_PERIOD_SHIFT && target.scope.shift.includes(bin.name.split(",")[shiftIndex]) && targetTimeWindowCheck(target, timeBinName, workday, time);
        };
        var devicePredicate = function devicePredicate(itemDevice, targetDevices) {
          return targetDevices.includes(itemDevice) && timeBinName.toUpperCase() === target.period && targetTimeWindowCheck(target, timeBinName, workday, time);
        };
        if (bin["bin"].includes("shift")) {
          var shiftIndex = bin["bin"].split(",").indexOf("shift");
          var deviceIndex = bin["bin"].split(",").indexOf("device");
          var itemDevice = bin.name.split(",")[deviceIndex];
          var targetDevices = target.scope.device_id.map(function (id) {
            return deviceHashMap[id];
          });
          return shiftPredicate(shiftIndex, itemDevice, targetDevices);
        }
        if (bin["bin"].includes("device")) {
          var _deviceIndex = bin["bin"].split(",").indexOf("device");
          var _itemDevice = bin.name.split(",")[_deviceIndex];
          var _targetDevices = target.scope.device_id.map(function (id) {
            return deviceHashMap[id];
          });
          return devicePredicate(_itemDevice, _targetDevices);
        }
      }).forEach(function (target) {
        var anticipatedTarget = getMetricValue(target.targetValue, metricName);
        if (anticipatedTarget > 0 && metricValue > 0) {
          yAxisMaxVal = Math.max(yAxisMaxVal, anticipatedTarget);
          return bin.markPoint.data.push({
            name: target.name + " for " + bin.name.replace(",", ", "),
            symbol: "roundedrect",
            label: {
              show: false
            },
            itemStyle: {
              color: "black",
              opacity: 0.5
            },
            symbolSize: [10, 5],
            value: anticipatedTarget,
            xAxis: formatByTimeBin(workday, timeBinName, time),
            yAxis: anticipatedTarget
          });
        }
      });
    });
  });
  var transformedAxis = axis.map(function (it) {
    return formatByTimeBin(it, timeBinName, time);
  });
  var legend = Array.from(bins[binNames]);
  return {
    axis: transformedAxis,
    series: series,
    legend: legend,
    metricName: metricName,
    timeBinName: timeBinName,
    yAxisMaxVal: Math.ceil(yAxisMaxVal)
  };
};